<div class="custom-modal novo-tomador">
  <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center" style="height: 170px">
    <mat-spinner color="primary" mode="indeterminate"></mat-spinner><br>
    Processando...
  </div>
  <div *ngIf="!isLoading">
    <mat-tab-group [selectedIndex]="btnNextPrev.index" dynamicHeight="true">
      <mat-tab>
        <ng-template mat-tab-label>
          <span>Dados Gerais</span>
          <mat-icon color="warn" [hidden]="!formCadastro.touched || !formCadastro.invalid">warning</mat-icon>
        </ng-template>
        <mat-card>
          <mat-card-content>
            <div class="position-help-icon">
              <mat-icon class="help-icon" [customTooltip]="tooltipHelp('')">help</mat-icon>
            </div>
            <form [formGroup]="formCadastro">
              <div class="element-inline mb-3">
                <h3 class="mr-3">Dados Gerais</h3>
                <mat-radio-group aria-label="Selecione uma opção" formControlName="optionUpload">
                  <mat-radio-button value="1" color="primary" [customTooltip]="tooltipHelp('ctesErros')">CT-es com Erros
                  </mat-radio-button>
                  <mat-radio-button value="2" color="primary" [customTooltip]="tooltipHelp('ctesAutorizados')">CT-es
                    Autorizados</mat-radio-button>
                  <mat-radio-button value="3" color="primary" [customTooltip]="tooltipHelp('nfsesAutorizados')">NFS-es
                    Autorizados</mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="element-inline">
                <mat-form-field style="flex-grow: 0">
                  <mat-label>Cliente:</mat-label>
                  <mat-select formControlName="clienteId" [customTooltip]="tooltipHelp('clienteId')"
                    placeholder="Cliente">
                            <mat-option><ngx-mat-select-search [formControl]="clienteMultiFilter" placeholderLabel="Buscar..."
        noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
                    <mat-option *ngFor="let cliente of filteredClientes | async" [value]="cliente?.id">
                      {{ cliente?.nome }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="optionUpload == '1'" class="d-flex pl-3">
                  <mat-form-field>
                    <mat-label>Data inicial:</mat-label>
                    <input matInput autocomplete="off" maskDate [matDatepicker]="dataInicio"
                      formControlName="dataInicio" />
                    <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
                    <mat-datepicker #dataInicio></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Data final:</mat-label>
                    <input matInput autocomplete="off" maskDate [matDatepicker]="dataFim" formControlName="dataFim" />
                    <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
                    <mat-datepicker #dataFim></mat-datepicker>
                  </mat-form-field>
                </div>
                <div *ngIf="optionUpload !== '1'" class="pl-3">
                  <button mat-stroked-button type="button"
                    matTooltip="O arquivo não pode conter campos numéricos formatados.">
                    <label for="fileUpload" style="margin-bottom: 0px; cursor: pointer;">
                      <i class="far fa-file-excel search-button cursor-pointer-icon"></i> Selecionar arquivo
                    </label>
                  </button>
                  {{ filename }}
                  <input type="file" id="fileUpload" name="fileUpload" accept=".xls, .xlsx" (change)="loadFile($event)"
                    hidden />
                </div>
              </div>
              <p *ngIf="optionUpload !== '1'">
                <small class="help-block">
                  <strong>Tipos de arquivos permitidos: </strong> *.xls ; *.xlsx
                </small>
                <br><br><br>
                <span style="cursor:pointer" matTooltip="Download de planilha modelo"
                  (click)="downloadExcelTemplateCTEAutorizado()">
                  <i class="fas fa-download"></i>&nbsp;Baixar arquivo de guia (template)
                </span>
              </p>
            </form>
          </mat-card-content>
        </mat-card>
      </mat-tab>
    </mat-tab-group>
  </div>
  <hr style="margin-bottom: -1px" />
  <mat-card-content>
    <div class="parent inline-flex-parent">
      <div class="atorButtonsLadoA pt-1">
        <h3><i class="fas fa-exclamation-triangle"></i> Aviso</h3>
        <p>
          O processamento só será iniciado após preencher todos os
          campos obrigatórios e clicar no botão
          <b>Avançar</b>
        </p>
      </div>
      <div class="atorButtonsLadoB float-right">
        <mat-dialog-actions class="d-flex float-right">
          <button mat-stroked-button [disabled]="btnNextPrev.prev" [hidden]="btnNextPrev.prev" (click)="navig('prev')">
            Voltar
          </button>
          <button mat-flat-button color="primary" [disabled]="
              btnNextPrev.next ||
              formCadastro.invalid ||
              !parent.habilitarInclusao || isLoading
            " [hidden]="!btnNextPrev.prev || detalhes.faturaLoteId" (click)="onClick()">
            Avançar
          </button>
        </mat-dialog-actions>
      </div>
    </div>
  </mat-card-content>
</div>
